import axios from "axios";
import { baseUrl } from "./baseUrl";
import { getPartnerToken } from "./auth";

const campaignApi = axios.create({
    baseURL: `${baseUrl}/partner/campaign`,
});

// Add auth token to requests
campaignApi.interceptors.request.use((config) => {
    const token = getPartnerToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Get All Campaigns
export const getAllCampaigns = async () => {
    try {
        const response = await campaignApi.get('/all-campaigns');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching all campaigns:", error);
        throw error;
    }
}

// Get Active Campaigns
export const getActiveCampaigns = async () => {
    try {
        const response = await campaignApi.get('/campaigns?status=active');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching active campaigns:", error);
        throw error;
    }
}

// Get Past/Inactive Campaigns
export const getPastCampaigns = async () => {
    try {
        const response = await campaignApi.get('/campaigns?status=inactive');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching past campaigns:", error);
        throw error;
    }
}

// Get Campaign Details
export const getCampaignDetails = async (campaignId) => {
    try {
        const response = await campaignApi.get(`/campaigns/${campaignId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign details:", error);
        throw error;
    }
}

// Create New Campaign Request
export const createCampaignRequest = async (data) => {
    try {
        const response = await campaignApi.post('/createCampaignRequest', data);
        return response.data;
    } catch (error) {
        console.error("Error creating campaign request:", error);
        throw error;
    }
}

// Get Campaign Creation Requests List
export const getCampaignCreationRequests = async () => {
    try {
        const response = await campaignApi.get('/getCampaignCreationRequests');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign creation requests:", error);
        throw error;
    }
}

// Get Campaign Creation Request Details
export const getCampaignCreationRequestDetails = async (requestId) => {
    try {
        const response = await campaignApi.get(`/getCampaignRequestDetails/${requestId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign creation request details:", error);
        throw error;
    }
}

// Create Campaign Modification Request
export const createCampaignModificationRequest = async (data) => {
    try {
        const response = await campaignApi.post('/modifyCampaignRequest', data);
        return response.data;
    } catch (error) {
        console.error("Error creating campaign modification request:", error);
        throw error;
    }
}

// Get Campaign Modification Requests List
export const getCampaignModificationRequests = async () => {
    try {
        const response = await campaignApi.get('/getCampaignModificationRequests');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign modification requests:", error);
        throw error;
    }
}

// Get Campaign Modification Request Details
export const getCampaignModificationRequestDetails = async (requestId) => {
    try {
        const response = await campaignApi.get(`/getCampaignModificationRequestDetails/${requestId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign modification request details:", error);
        throw error;
    }
}

// Get Campaign Impact Summary (All Campaigns)
export const getCampaignImpactSummary = async () => {
    try {
        const response = await campaignApi.get('/impact/summary');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching campaign impact summary:", error);
        throw error;
    }
}

// Get All Campaign Impacts (Individual)
export const getAllCampaignImpacts = async () => {
    try {
        const response = await campaignApi.get('/impact/all');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching all campaign impacts:", error);
        throw error;
    }
}
